import React, { useState } from "react";
import { Popover, useTheme } from "@mui/material";
import OrderTable from "../order-management-components/order-table";
import MobileOrderCard from "../order-management-components/mobile-order-card";
import CustomPagination from "../pagination";
import FilterModal from "../filterModal";
import OrderDetailsModal from "../orderDetailsModal";
import { isMobile } from "../../globalStyles/mobile";
import M2OOrderDetailsModal from "../m2o-order-details-modal";

const OrderList = ({
  data,
  style,
  fetchOrderData,
  onChangeFilter,
  filterData,
  setPage,
  setRowsPerPage,
  rowsPerPage,
  page,
  dataCount,
  type = "M2C", // Default type is M2C (Merchant to Customer)
  loading,
}) => {
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [openM2OView, setOpenM2OView] = useState(false);
  const [edit, setEdit] = useState(false);
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [anchorElFilter, setAnchorElFilter] = useState(null);
  const [selectedFilterData, setSelectedFilterData] = useState({
    key: "",
    filter: [],
    sort: 0,
    id: "_id",
    displayKey: "name",
    fetchApi: () => {},
    loadMoreButton: false,
    options: [],
    searchKey: "",
    type: "list",
    placeholderKey: "",
  });
  const startIndex = page * rowsPerPage;
  const theme = useTheme();
  const defaultColor = "#D13438";
  const iconColor = theme.palette?.primary?.main || defaultColor;
  const roles = JSON.parse(localStorage.getItem("roles"));
  const handleOpenFilter = (event, filterKey) => {
    setAnchorElFilter(event.currentTarget);
    setOpenFilterModal(true);
    setSelectedFilterData(filterData?.columns.find((x) => x?.key == filterKey));
  };

  const handleSaveFilter = (
    selectedOptions,
    filterKey,
    sortOrder,
    searchKey,
  ) => {
    onChangeFilter({
      key: filterKey,
      filter: selectedOptions,
      sort: sortOrder,
      searchKey: searchKey,
    });
    handleCloseFilter();
  };
  const handleCloseFilter = () => {
    setAnchorElFilter(null);
    setOpenFilterModal(false);
  };

  const handleViewClick = (order) => {
    setModalOpen(true);
    setSelectedOrder(order);
  };

  const handleM2OViewClick = (order) => {
    setOpenM2OView(true);
    setSelectedOrder(order);
  };

  // Row click opens the order's details — M2O orders get their own detail
  // modal (asn/PO-shaped), every other order type gets the standard one.
  // This used to be reachable only through the row's 3-dot menu's "Order
  // Details" / "M2O View" entries; the menu (and the Order Flow / Warehouse /
  // Cancel / Expose-to-Client actions that lived in it, plus the inline
  // dummy-data "tracking" row expansion that used to be the row's click
  // target) has been removed from this page.
  const handleRowClick = (order) => {
    if (order?.type === "M2O") {
      handleM2OViewClick(order);
    } else {
      handleViewClick(order);
    }
  };

  return (
    <>
      <div
        style={{
          overflowY: "scroll",
          display: "flex",
          maxHeight: `calc(100vh - 210px)`,
          width: "100%",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          "&::WebkitScrollbar": { width: 0 },
          flexDirection: "column",
        }}
      >
        {isMobile() ? (
          <MobileOrderCard data={data} handleRowClick={handleRowClick} />
        ) : (
          <OrderTable
            type={type}
            orderData={data}
            filterData={filterData}
            handleRowClick={handleRowClick}
            startIndex={startIndex}
            roles={roles}
            iconColor={iconColor}
            handleOpenFilter={handleOpenFilter}
            loading={loading}
          />
        )}
      </div>
      <CustomPagination
        dataCount={dataCount}
        rowsPerPage={filterData.limit}
        page={page}
        setPage={setPage}
        setRowsPerPage={setRowsPerPage}
        disableNext={dataCount <= (page + 1) * filterData.limit}
      />
      <Popover
        open={Boolean(anchorElFilter)}
        anchorEl={anchorElFilter}
        onClose={handleCloseFilter}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        disableScrollLock={true}
      >
        <FilterModal
          open={openFilterModal}
          onClose={handleCloseFilter}
          options={selectedFilterData?.options}
          selectedValues={selectedFilterData?.filter}
          onSave={handleSaveFilter}
          currentSortOrder={selectedFilterData?.sort}
          filterKey={selectedFilterData?.key}
          hasMore={selectedFilterData?.loadMoreButton}
          displayKey={selectedFilterData?.displayKey}
          id={selectedFilterData?.id}
          fetchApi={selectedFilterData?.fetchApi}
          searchKey={selectedFilterData?.searchKey}
          type={selectedFilterData?.type}
          placeholderKey={selectedFilterData?.placeholderKey}
        />
      </Popover>

      <OrderDetailsModal
        open={modalOpen}
        edit={edit}
        fetchOrderData={fetchOrderData}
        onClose={() => {
          setModalOpen(false);
          setEdit(false);
          setSelectedOrder(null);
        }}
        order={selectedOrder}
      />
      <M2OOrderDetailsModal
        open={openM2OView}
        onClose={() => setOpenM2OView(false)}
        orderData={selectedOrder}
      />
    </>
  );
};

export default OrderList;
